// Packages
import React from "react";

// Content Component
import ContentSwitch from './components/ContentSwitch';
import ContentAP from './components/ContentAP';

// Local Const
import { DEVICE_ATTR } from 'const';

const ConfigProvisioningContent = ({
  auth,
  alertInfo,
  setAlertInfo,
  defaultConfig,
  setDefaultConfig,
  selectedDrawerTarget,
  isOpenEditDrawer,
  showEditGeneral,
  closeCallback,
}) => {

  return (
    <>
      {
        selectedDrawerTarget?.deviceCategory === DEVICE_ATTR.types.SW &&
        <ContentSwitch
          {...{
            auth,
            alertInfo,
            setAlertInfo,
            defaultConfig,
            setDefaultConfig,
            selectedDrawerTarget,
            isOpenEditDrawer,
            showEditGeneral,
            closeCallback,
          }}
        />
      }
      {
        selectedDrawerTarget?.deviceCategory === DEVICE_ATTR.types.AP &&
        <ContentAP
          {...{
            auth,
            alertInfo,
            setAlertInfo,
            defaultConfig,
            setDefaultConfig,
            selectedDrawerTarget,
            isOpenEditDrawer,
            showEditGeneral,
            closeCallback,
          }}
        />
      }
    </>
  )
};

export default ConfigProvisioningContent;